import React from "react";
import { TextField, Card, Typography, CardContent, CardActions, Button } from "@mui/material";
import { D } from "../include";



export class EmailManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email_to: "flavioluis.mello@gmail.com",
      subject: "Mensagem de Teste",
      mensagem: "",
      file_id_list: "1816,1817",
    };
  }  
  
 
  handleSendEMailMessage = (email_phone, subject, message, file_id_list) => {   
    this.props.api
        .post('/CommunicationEmailMessage', { email_phone: email_phone, message: message, subject: subject, file_ids: file_id_list })
        .then((r) => {
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Email enviado');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao tentar enviar email'));
  }  
  
  

  
    

  
    
  render() {
    return (
      <D className="col e aF scD" style={{ padding: "2rem" }}>
        <D className="col w aF">
          <D className="row w aF" style={{ flexFlow: "wrap" }}>
            <D className="e hide-md" />
              
              <>               
               <Card variant="outlined" sx={{ maxWidth: 375, margin: 2 }}>
                 <CardContent>
                   <Typography variant="h6" component="div">Enviar mensagem</Typography>
                   <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>Usa o mecanismo de comunicação</Typography>
                   <TextField label="Para " variant="outlined" value={this.state.email_to} onChange={(e) => this.setState({ email_to: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Subject " variant="outlined" value={this.state.subject} onChange={(e) => this.setState({ subject: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Mensagem" variant="outlined" value={this.state.mensagem} onChange={(e) => this.setState({ mensagem: e.target.value })}/>
                   <D h="0.6rem" />
                   <TextField label="Anexos (lista de file_ids com ,)" variant="outlined" value={this.state.file_id_list} onChange={(e) => this.setState({ file_id_list: e.target.value })}/>
                 </CardContent>
                 <CardActions>
                   <Button size="small" onClick={() => this.handleSendEMailMessage(this.state.email_to, this.state.subject, this.state.mensagem, this.stare.file_id_list)}>Email</Button>
                 </CardActions>  
               </Card> 
              </>
                           
              
            <D className="e hide-md" />
          </D>
        </D>
      </D>
    );
  }
}























